import type { HeadingProps } from '@components/text/types/props';
import { Madi } from 'app/fonts';
import classNames from 'classnames';
import type { ReactElement } from 'react';
import React from 'react';
import { validateString } from 'utils/validate-string';

import styles from './text.module.scss';

const rootClass = validateString(styles.h1);
const responsiveClass = validateString(styles.responsive);

function H1({
  children,
  className,
  responsive = true,
  style,
}: HeadingProps): ReactElement {
  return (
    <h1
      className={classNames(rootClass, className, Madi.className, {
        [responsiveClass]: responsive,
      })}
      style={style}
    >
      {children}
    </h1>
  );
}

export default H1;
